<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="headline primary white--text">{{$t('lang.authentication')}}</v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-form ref="form" class="mt-4">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field dense v-model="name" outlined clearable required :rules="nameRules" :placeholder="$t('lang.nameHint')" :prefix="$t('lang.name')"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field dense ref="phoneOrEmail" v-model="phoneOrEmail" outlined clearable required :rules="phoneOrEmailRules" :placeholder="$t('lang.phoneOrEmailHint')" :prefix="$t('lang.phoneOrEmail')"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field dense v-model="verificationCode" outlined clearable required :rules="nullRules" :placeholder="$t('lang.verificationCodeHint')" :prefix="$t('lang.verificationCode')">
                    <template v-slot:append>
                      <v-btn style="text-transform:none;" small color="primary" :disabled="disabled" @click="getCode()">{{VerificationText}}</v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" dense>
            <v-col cols="5">
              <v-btn block  style="text-transform:none;" @click="dialog = false;$emit('fatherEvent', 'login')">{{$t('lang.cancel')}}</v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn block style="text-transform:none;" color="primary" @click="login()">{{$t('lang.login')}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>
<style>
</style>
<script>
export default {
  name: 'Login',
  props: ['id'],
  computed: {
    VerificationText () {
      return this.text
    }
  },
  data () {
    return {
      dialog: true,
      snackbar: false,
      disabled: false,
      msg: '',
      name: '',
      phoneOrEmail: '',
      verificationCode: '',
      text: this.$t('lang.getVerificationCode'),
      nullRules: [],
      nameRules: [],
      phoneOrEmailRules: [],
      count: '',
      timer: null
    }
  },
  mounted () {
    this.initRoles()
  },
  methods: {
    initRoles () {
      this.nullRules = [
        v => !!v || this.$t('lang.verificationCodeHint')
      ]
      this.nameRules = [
        v => !!v || this.$t('lang.nameCannotBeEmpty')
      ]
      this.phoneOrEmailRules = [
        v => !!v || this.$t('lang.phoneOrEmailCannotBeEmpty'),
        v => (v && ((v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/.test(v))) || this.$t('lang.correctPhoneOrEmail')
      ]
    },
    login () {
      if (this.$refs.form.validate()) {
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API_TWO',
          url: '/ComActivity/QueryUserEssayDoc',
          data: {
            Aid: this.id,
            TrueName: this.name,
            PhoneOrEmail: this.phoneOrEmail,
            Code: this.verificationCode
          }
        }).then(res => {
          console.log(res)
          if (res.data.ret === 0) {
            this.$store.commit('setLogin2', true)
            this.$store.commit('setLogin2Data', res.data.data)
            this.dialog = false
            this.$emit('fatherEvent', 'login')
          } else {
            this.msg = res.data.msg
            this.snackbar = true
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getCode () {
      this.disabled = true
      console.log(this.phoneOrEmail)
      this.$http({
        method: 'post',
        requestBase: 'VUE_APP_API_TWO',
        url: '/ComActivity/SendVerificationCode',
        params: {
          input: this.phoneOrEmail
        }
      }).then(res => {
        console.log(res)
        if (res.data.ret === 0) {
          this.countdown()
        } else {
          this.disabled = false
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.disabled = false
        console.log(e)
      })
    },
    countdown () {
      const TIME_COUNT = 60 * 5
      if (!this.timer) {
        this.count = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
            if (this.$store.getters.getLanguage === 0) {
              this.text = this.count + '秒'
            } else {
              this.text = this.count + 'second'
            }
          } else {
            this.disabled = false
            this.text = this.$t('lang.getVerificationCode')
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    }
  }
}
</script>
